'use client';

import {motion} from 'framer-motion';
import useTopStyle from 'utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from 'animation/heroVariants';
import spanVariants from 'animation/spanVariants';
import PartnersHeroSvg1 from 'animation/svg-anim/PartnersHeroSvg1';
import PartnersHeroSvg2 from 'animation/svg-anim/PartnersHeroSvg2';
import PartnersHeroSvg1Mobile from 'animation/svg-anim/PartnersHeroSvg1Mobile';
import PartnersHeroSvg2Mobile from 'animation/svg-anim/PartnersHeroSvg2Mobile';
import {tagline} from 'data/common';

const Nbsp = () => '\u00A0';

const PartnersHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='partners-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-line'>
          <PartnersHeroSvg1 />
          <PartnersHeroSvg2 />
        </div>
        <div className='bg-line-mobile'>
          <PartnersHeroSvg1Mobile />
          <PartnersHeroSvg2Mobile />
        </div>
        <div className='logo'></div>
        <div className='data'></div>
        <h2 className='title'>
          Expand your portfolio with a comprehensive, easy to deploy stack.
          <br />
          <motion.span
            className='highlight'
            initial={'hidden'}
            animate={'visible'}
            transition={{
              duration: 0.8,
              delay: 0.8,
              ease: 'easeInOut'
            }}
            variants={spanVariants}
          >
            Collaborate with us.
          </motion.span>
        </h2>
        <BookBtn text='Become a partner' />
      </div>
    </motion.section>
  );
};

export default PartnersHero;

